import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { Link } from "@quintype/components";
import { Icon } from "../icon";
import Contributor from "../contributor/index";
import ResponsiveImageWithFallback from "../responsive-image-with-fallback";

import { getStoryData, generateImageSources } from "../../utils/utils";
import { isPremium } from "../../../../isomorphic/data/story";

import styles from "./styles.m.css";

export const StoryCardML4x3DP2x1 = ({ story, className = "", cardWithImageZoom = true }) => {
  const storyData = getStoryData(story);
  const headline = storyData.headline;

  if (!(headline && story.url)) {
    return null;
  }

  const contributorName = get(story, ["authors", 0, "name"], null);
  const contributorRole = get(story, ["authors", 0, "contributor-role", "name"], "");
  const externalLink = get(story, ["metadata", "reference-url"]);

  return (
    <Link
      aria-label={`${"Read full story: "} ${storyData.headline}`}
      href={externalLink || story.url}
      externalLink={externalLink}
      className={`${styles["base"]} ${className} ${cardWithImageZoom ? "card-with-image-zoom" : ""}`}
    >
      <div className={styles["image-container"]}>
        <ResponsiveImageWithFallback
          className={styles["image-wrapper"]}
          slug={storyData.imageS3Key}
          metadata={storyData.imageMetadata}
          isPremium={isPremium(story)}
          alt={storyData.imageCaption}
          imgParams={{ auto: ["format", "compress"] }}
          sources={generateImageSources(
            { aspectRatio: [4, 3], screenWidthCoverage: 0.25 },
            { aspectRatio: [2, 1], screenWidthCoverage: 0.17 }
          )}
        />
      </div>
      <div className={styles["text-wrapper"]}>
        {contributorName && (
          <Contributor name={contributorName} type={contributorRole} className={styles["contributor"]} />
        )}
        <h3 className={`${styles["headline"]}`}>{headline}</h3>
      </div>
    </Link>
  );
};

export const StoryCardML4x3DP2x1WithLabel = ({ story, className, defaultLabel = "Others" }) => {
  if (story.label === "null" || story.label === null) {
    story.label = defaultLabel;
  }
  return (
    <div className={`${styles["story-card-with-label-wrapper"]} ${className}`}>
      {story.label && (
        <div className={styles["headline-wrapper"]}>
          <Icon type={"bullet-arrow"} className={styles["bullet-icon"]} />
          <h2 className={styles["headline-label"]}>{story.label}</h2>
        </div>
      )}
      <StoryCardML4x3DP2x1 story={story} className={styles.card} />
    </div>
  );
};

StoryCardML4x3DP2x1.propTypes = {
  className: PropTypes.string,
  cardWithImageZoom: PropTypes.bool,
  story: PropTypes.shape({
    id: PropTypes.string,
    contributors: PropTypes.arrayOf(
      PropTypes.shape({
        "role-name": PropTypes.string,
        authors: PropTypes.arrayOf(
          PropTypes.shape({
            name: PropTypes.string
          })
        )
      })
    ),
    headline: PropTypes.string.isRequired,
    metadata: PropTypes.shape({
      "reference-url": PropTypes.string
    }),
    alternative: PropTypes.shape({
      home: PropTypes.shape({
        default: PropTypes.shape({
          headline: PropTypes.string
        })
      })
    }),
    slug: PropTypes.string.isRequired,
    "hero-image-metadata": PropTypes.shape({
      height: PropTypes.number,
      width: PropTypes.number,
      "aspect-ratio": PropTypes.arrayOf(PropTypes.number)
    }),
    "hero-image-s3-key": PropTypes.string,
    "hero-image-caption": PropTypes.string
  })
};

StoryCardML4x3DP2x1WithLabel.propTypes = {
  defaultLabel: PropTypes.string,
  story: StoryCardML4x3DP2x1.propTypes.story,
  className: PropTypes.string
};

export default StoryCardML4x3DP2x1;
